import { render } from "./Entities.vue?vue&type=template&id=3745bf3e"
import script from "./Entities.vue?vue&type=script&lang=ts"
export * from "./Entities.vue?vue&type=script&lang=ts"
script.render = render

export default script